module.exports = __webpack_public_path__ + "img/compatability_love.f640cc6f.jpg";